import * as React from 'react';
import { FC, useState, createRef, useEffect } from 'react';
import { useApi } from '../@context/Api';
import { createStyles, makeStyles } from '@material-ui/styles';
import submitIcon from '../assets/svgs/marinex_submit.svg';
import stylesheet, { blue, backgroundColor } from 'src/constants/stylesheet';
import classNames from 'classnames';
import Menu from './Menu';
import useRouter from 'use-react-router';
import { Language } from 'src/utils/Languages';
import { Link } from 'react-router-dom';
import mediaQueries from 'src/constants/responsive';
import { Responsive } from 'src/@context/Responsive';
import MenuMobile from './MenuMobile';
import fonts from 'src/constants/fonts';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'sticky',
      top: 0,
      zIndex: 20,
      flex: '0 0 auto',
    },
    header: {
      position: 'relative',
      backgroundColor,
      zIndex: 1,
    },
    headerInner: {
      position: 'relative',
      maxWidth: 1200,
      margin: '0 auto',
      padding: '15px',

      display: 'flex',
      alignItems: 'center',

      [mediaQueries.Tablet]: {
        justifyContent: 'space-between',
      },
    },
    logo: {
      [mediaQueries.BeforeTablet]: {
        flex: '0 0 150px',
      },
      [mediaQueries.TabletLandScape]: {
        margin: '0 15px',
        flex: '0 0 228px',
      },
      [mediaQueries.AfterTablet]: {
        margin: '0 15px',
        flex: '0 0 228px',
      },
    },
    logoLink: {
      display: 'block',
      lineHeight: 0,

      '& svg': {
        width: '100%',
        height: 'auto',
      },
    },
    headerHighlight: {
      flex: '1 1 auto',
      margin: '0 15px',
      fontSize: '1.4666rem',
      textAlign: 'center',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      lineHeight: 1,
      transform: 'translateY(1px)',
      letterSpacing: 1,

      [mediaQueries.BeforeTablet]: {
        display: 'none',
      },
      [mediaQueries.TabletPortrait]: {
        display: 'none',
      },
    },
    secondaryNav: {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'center',

      [mediaQueries.BeforeTablet]: {
        marginLeft: 'auto',
      },
      [mediaQueries.TabletLandScape]: {
        margin: '0 15px',
      },
      [mediaQueries.AfterTablet]: {
        margin: '0 15px',
      },
    },
    magButton: {
      width: 20,
      marginRight: 10,
      cursor: 'pointer',
      lineHeight: 0,

      [mediaQueries.Mobile]: {
        marginRight: 0,
        display: 'block',
      },
      [mediaQueries.TabletPortrait]: {
        marginRight: 0,
        display: 'block',
      },
    },
    burguerButton: {
      display: 'none',
      width: 20,
      cursor: 'pointer',
      lineHeight: 0,

      [mediaQueries.Mobile]: {
        marginLeft: 15,
        display: 'block',
      },
      [mediaQueries.TabletPortrait]: {
        marginLeft: 15,
        display: 'block',
      },
    },
    magIcon: {
      width: '100%',
    },
    langLink: {
      marginLeft: 5,
      color: '#9FCFFF',

      ...fonts.Condensed,

      [mediaQueries.Mobile]: {
        display: 'none',
      },
      [mediaQueries.TabletPortrait]: {
        display: 'none',
      },
    },
    langLinkActive: {
      color: blue,
    },
    search: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor,

      opacity: 0,
      pointerEvents: 'none',

      display: 'flex',
      alignItems: 'center',

      [mediaQueries.BeforeTablet]: {
        margin: '0 0 0 35px',
      },
      [mediaQueries.TabletLandScape]: {
        margin: '0 30px 0 60px',
      },
      [mediaQueries.AfterTablet]: {
        margin: '0 30px 0 60px',
      },
    },
    searchVisible: {
      opacity: 1,
      pointerEvents: 'initial',
    },
    searchIconContainer: {
      flex: '0 0 27px',
    },
    searchIcon: {
      width: '100%',
    },
    searchInputContainer: {
      flex: '1 1 auto',
      margin: '0 30px 0 10px',
    },
    searchInput: {
      ...stylesheet.TitleH2,
      display: 'block',
      width: '100%',
      padding: 10,
      margin: 0,
      background: 'transparent',
      border: 0,
    },
    searchCloseContainer: {
      flex: '0 0 16px',
      cursor: 'pointer',

      '& svg': {
        display: 'block',
      },
    },
    searchCloseIcon: {
      width: '100%',
    },
    divison: {
      height: '40%',
      width: 2,
      backgroundColor: blue,
      margin: '0 15px',
    },
    searchSubmit: {
      flex: '0 0 24px',
      cursor: 'pointer',
      background: 'transparent',
      border: 'none',
      padding: 0,
      [mediaQueries.BeforeTablet]: {
        marginRight: 15,
      },
      [mediaQueries.TabletPortrait]: {
        marginRight: 15,
      },
      [mediaQueries.TabletLandScape]: {
        marginRight: 6,
      },
      [mediaQueries.AfterTablet]: {
        marginRight: 6,
      },
    },
    searchSubmitIcon: {
      width: '100%',
      display: 'block',
    },
    fill: {
      fill: blue,
    },
    menu: {
      [mediaQueries.Mobile]: {
        display: 'none',
      },
      [mediaQueries.TabletPortrait]: {
        display: 'none',
      },
    },
    menuMobile: {
      position: 'absolute',
      top: 0,
      width: '100%',
      height: '100vh',
      paddingTop: 50,

      transform: 'translateY(-100%)',
      backgroundColor: 'white',
      transition: 'transform .4s ease',

      '&$showMobileMenu': {
        transform: 'translateY(0)',
      },

      '$showMobileMenu &': {
        transform: 'translateY(0)',
      },

      [mediaQueries.TabletLandScape]: {
        display: 'none',
      },
      [mediaQueries.AfterTablet]: {
        display: 'none',
      },
    },
    showMobileMenu: {},
    langActive: {
      color: blue,
    },
  })
);

export type HeaderProps = {};

type Props = HeaderProps;

const Header: FC<Props> = () => {
  const cls = useStyles();
  const [searchVisible, setSearchVisible] = useState(false);
  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const inputRef = createRef<HTMLInputElement>();
  const { app } = useApi();
  const { history } = useRouter();
  const config = app && app.Config;

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handleKeyPress = (e: KeyboardEvent) => {
    switch (e.keyCode) {
      case 27: // esc
        setSearchVisible(false);
        break;
      default:
        break;
    }
  };

  const toggleSearchVisibility = () => {
    if (!searchVisible && inputRef.current) {
      inputRef.current.focus();
    }
    setSearchVisible((prevState) => !prevState);
  };

  const toggleMenuMobile = () => {
    setShowMenuMobile(!showMenuMobile);
  };

  const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!inputRef || !inputRef.current || !inputRef.current.value) {
      return;
    }
    if (!app) {
      return;
    }

    const searchAction = `/${Language}/${
      app.SearchPage.UID
    }?q=${encodeURIComponent(inputRef.current.value)}`;
    history.push(searchAction);
  };

  const burguerSVG = (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 22 18'
      enableBackground='new 0 0 22 18;'
    >
      <path
        className={cls.fill}
        d='M0,17.9h22v-2.8H0V17.9z M0,10.4h22V7.6H0V10.4z M0,2.9h22V0.1H0V2.9z'
      />
    </svg>
  );

  const magSVG = (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 19.6 19.6'
      enableBackground='new0 0 19.6 19.6;'
    >
      <g>
        <path
          className={cls.fill}
          d='M2.4,7.7c0,1.4,0.6,2.7,1.7,3.8s2.4,1.7,3.8,1.7s2.7-0.5,3.7-1.5s1.5-2.3,1.5-3.7c0-1.5-0.6-2.7-1.7-3.8
            c-1-1.2-2.3-1.8-3.7-1.8C6.2,2.4,5,2.9,4,4C2.9,5,2.4,6.2,2.4,7.7 M19.1,16.5c0.5,0.6,0.5,1.1,0.1,1.5l-1.1,1.1
            c-0.6,0.5-1.1,0.5-1.7,0l-4.7-4.7c-1.2,0.7-2.5,1-3.8,1c-2.1,0-3.9-0.8-5.5-2.3S0.1,9.8,0.1,7.7s0.7-3.9,2.2-5.4s3.3-2.2,5.4-2.2
            s3.9,0.8,5.5,2.3c1.6,1.6,2.4,3.4,2.4,5.5c0,1.4-0.4,2.8-1.1,4L19.1,16.5z'
        />
      </g>
    </svg>
  );

  const logoSVG = (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 228 23'
      enableBackground='new 0 0 228 23;'
    >
      <g>
        <path
          className={cls.fill}
          d='M4.4,11.5c0,0,0.1,0.1,0.1,0.2l11.2,11.2c0.1,0.1,0.2,0.1,0.3,0l11.2-11.2c0.1-0.1,0.1-0.2,0-0.3L16.1,0.1
            C16,0,15.8,0,15.7,0.1L4.5,11.3C4.4,11.4,4.4,11.5,4.4,11.5L4.4,11.5'
        />
        <path
          className={cls.fill}
          d='M4.4,11.5C4.3,11.5,4.3,11.5,4.4,11.5c0,0-0.1-0.1-0.2-0.2l-4-4C0.1,7.2,0,7.2,0,7.3v8.3
            c0,0.1,0.1,0.2,0.2,0.1l4-4C4.3,11.6,4.4,11.5,4.4,11.5'
        />
        <path
          className={cls.fill}
          d='M4.4,11.5L4.4,11.5L4.4,11.5L4.4,11.5C4.3,11.5,4.3,11.5,4.4,11.5'
        />
        <path
          className={cls.fill}
          d='M46.6,12.9c-0.2,0.4-0.2,0.4-0.4,0L40.5,1c-0.1-0.1-0.2-0.2-0.3-0.2h-3.4c-0.1,0-0.2,0.1-0.2,0.2v20.8
            c0,0.1,0.1,0.2,0.2,0.2h3.4c0.1,0,0.2,0,0.2-0.2V8.6c0-0.6,0.1,0,0.3,0.5l4.1,9.1c0.1,0.1,0.2,0.2,0.3,0.2h2.4
            c0.1,0,0.3-0.1,0.3-0.2l4-9.1c0.1-0.3,0.3-1.2,0.3-0.4v13.2c0,0.2,0.1,0.2,0.2,0.2h3.4c0.1,0,0.2-0.1,0.2-0.2V1.1
            c0-0.1-0.1-0.2-0.2-0.2h-3.4C52.2,0.9,52,1,52,1.1L46.6,12.9z'
        />
        <path
          className={cls.fill}
          d='M66,14.5c-0.1,0-0.2-0.1-0.1-0.2l2.9-8.6c0-0.1,0.1-0.1,0.1,0l2.9,8.6c0,0.1,0,0.2-0.2,0.2H66z M67,0.8
            c-0.1,0-0.2,0.1-0.3,0.2l-7.3,20.9c0,0.1,0,0.2,0.1,0.2H63c0.1,0,0.2-0.1,0.3-0.2l1.2-3.7c0-0.1,0.2-0.2,0.3-0.2h8
            c0.1,0,0.2,0.1,0.3,0.2l1.2,3.7c0,0.1,0.2,0.2,0.3,0.2h3.6c0.1,0,0.2-0.1,0.1-0.2L71.1,1c0-0.1-0.2-0.2-0.3-0.2H67z'
        />
        <path
          className={cls.fill}
          d='M90.2,10.4h-4.3c-0.1,0-0.2-0.1-0.2-0.2V4.4c0-0.1,0.1-0.2,0.2-0.2H90c2.5,0,3.9,1,3.9,3
            C93.9,10.5,90.7,10.4,90.2,10.4 M97.8,7.3c0-4-2.3-6.4-7.8-6.4h-8c-0.1,0-0.2,0.1-0.2,0.2v20.8c0,0.1,0.1,0.2,0.2,0.2h3.5
            c0.1,0,0.2-0.1,0.2-0.2v-7.8c0-0.1,0.1-0.2,0.2-0.2h3.9c0.1,0,0.2,0.1,0.3,0.2l3.2,7.8c0,0.1,0.2,0.2,0.3,0.2h3.7
            c0.1,0,0.2-0.1,0.1-0.2L94,13.4c0-0.1-0.1-0.3,0.1-0.3C94,13.1,97.8,11.9,97.8,7.3'
        />
        <path
          className={cls.fill}
          d='M103.1,21.9c0,0.1,0.1,0.2,0.2,0.2h3.8c0.1,0,0.2-0.1,0.2-0.2V1.1c0-0.1-0.1-0.2-0.2-0.2h-3.8
            c-0.1,0-0.2,0.1-0.2,0.2V21.9z'
        />
        <path
          className={cls.fill}
          d='M127.1,15C127.1,15.1,127,15.1,127.1,15l-9-14c-0.1-0.1-0.2-0.2-0.3-0.2H114c-0.1,0-0.2,0.1-0.2,0.2v20.8
            c0,0.1,0.1,0.2,0.2,0.2h3.5c0.1,0,0.2-0.1,0.2-0.2V7.6c0-0.1,0-0.1,0.1,0l9,14.2c0.1,0.1,0.2,0.2,0.3,0.2h3.7
            c0.1,0,0.2-0.1,0.2-0.2L131,1c0-0.1-0.1-0.2-0.2-0.2h-3.5c-0.1,0-0.2,0.1-0.2,0.2L127.1,15z'
        />
        <path
          className={cls.fill}
          d='M137.8,21.9c0,0.1,0.1,0.2,0.2,0.2h13.9c0.1,0,0.2-0.1,0.2-0.2v-3.1c0-0.1-0.1-0.2-0.2-0.2H142
            c-0.1,0-0.2-0.1-0.2-0.2V13c0-0.1,0.1-0.2,0.2-0.2h8.4c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2H142
            c-0.1,0-0.2-0.1-0.2-0.2V4.6c0-0.1,0.1-0.2,0.2-0.2h9.9c0.1,0,0.2-0.1,0.2-0.2V1c0-0.1-0.1-0.2-0.2-0.2H138c-0.1,0-0.2,0.1-0.2,0.2
            V21.9z'
        />
        <path
          className={cls.fill}
          d='M174.6,0.8c0.1-0.1,0-0.2-0.1-0.2h-4.3c-0.1,0-0.3,0.1-0.3,0.2l-4.4,6.5c-0.1,0.1-0.2,0.1-0.2,0l-4.2-6.5
            c-0.1-0.1-0.2-0.2-0.3-0.2h-4.5c-0.1,0-0.2,0.1-0.1,0.1c0,0.1,0.1,0.2,0.2,0.3l6.5,9.4c0.1,0.1,0.1,0.3,0,0.4l-7.5,11.1
            c-0.1,0.1,0,0.2,0.1,0.2h4.2c0.1,0,0.3-0.1,0.3-0.2l5.1-7.6c0.1-0.1,0.2-0.1,0.2,0l5,7.6c0.1,0.1,0.2,0.2,0.3,0.2h4.5
            c0.1,0,0.2-0.1,0.1-0.2l-7.4-11.1c-0.1-0.1-0.1-0.3,0-0.4L174.6,0.8z'
        />
        <path
          className={cls.fill}
          d='M199.4,9.5c-1.3-0.1-4.6-0.3-4.6-2.6c0-1.9,1.2-3,3.6-3c2.3,0,4.2,1.6,4.3,1.6c0.1,0.1,0.2,0.1,0.3,0l2.3-2.2
            c0.1-0.1,0.1-0.2,0-0.3s-3.1-2.6-6.8-2.6c-4.6,0-7.5,2.6-7.5,6.5c0,5.5,5.7,5.9,7.5,6.1c1.2,0.2,3.9,0.1,3.9,2.9
            c0,2.1-1.8,2.9-4.2,2.9c-2.5,0-5-2.1-5.1-2.1c-0.1-0.1-0.2-0.1-0.3,0l-2.4,2.3c-0.1,0.1-0.1,0.2,0,0.3c0.1,0.1,3.1,3,7.7,3
            c2.5,0,8.1-0.7,8.1-6.5C206.3,11,202.7,9.7,199.4,9.5'
        />
        <path
          className={cls.fill}
          d='M215.6,14.5c-0.1,0-0.2-0.1-0.1-0.2l2.9-8.6c0-0.1,0.1-0.1,0.1,0l2.9,8.6c0,0.1,0,0.2-0.1,0.2H215.6z M220.7,1
            c0-0.1-0.2-0.2-0.3-0.2h-3.8c-0.1,0-0.2,0.1-0.3,0.2L209,21.9c0,0.1,0,0.2,0.1,0.2h3.5c0.1,0,0.2-0.1,0.3-0.2l1.2-3.7
            c0-0.1,0.2-0.2,0.3-0.2h8c0.1,0,0.2,0.1,0.3,0.2l1.2,3.7c0,0.1,0.2,0.2,0.3,0.2h3.6c0.1,0,0.2-0.1,0.1-0.2L220.7,1z'
        />
      </g>
    </svg>
  );

  const closeSVG = (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 18 18'
      enableBackground='new 0 0 18 18;'
    >
      <polygon
        className={cls.fill}
        points='18,1.8 16.2,0 9,7.2 1.8,0 0,1.8 7.2,9 0,16.2 1.8,18 9,10.8 16.2,18 18,16.2 10.8,9 '
      />
    </svg>
  );

  const handleMenuCLick = () => setShowMenuMobile(false);

  return (
    <div
      id='header'
      className={classNames(cls.root, showMenuMobile && cls.showMobileMenu)}
    >
      <header className={cls.header}>
        <div className={cls.headerInner}>
          <figure className={cls.logo}>
            <Link to={`/${Language}`} className={cls.logoLink}>
              {logoSVG}
            </Link>
          </figure>
          <div className={cls.headerHighlight}>
            {config && config.HeaderHighlight}
          </div>
          <nav className={cls.secondaryNav}>
            <figure className={cls.magButton} onClick={toggleSearchVisibility}>
              {magSVG}
            </figure>
            <figure className={cls.burguerButton} onClick={toggleMenuMobile}>
              {!showMenuMobile && burguerSVG}
              {showMenuMobile && closeSVG}
            </figure>
            <a
              href='?switch-lang=de'
              className={classNames(
                cls.langLink,
                Language === 'de' && cls.langActive
              )}
            >
              D
            </a>
            {/*
              <a 
              href="?switch-lang=en"
              className={classNames(cls.langLink, Language === 'en' && cls.langActive)}
              >
              E
              </a> */}
            <a
              href='?switch-lang=fr'
              className={classNames(
                cls.langLink,
                Language === 'fr' && cls.langActive
              )}
            >
              F
            </a>
            <a
              href='?switch-lang=it'
              className={classNames(
                cls.langLink,
                Language === 'it' && cls.langActive
              )}
            >
              I
            </a>
          </nav>

          <form
            // tslint:disable-next-line:jsx-no-lambda
            onSubmit={(e) => submitForm(e)}
            className={classNames(
              cls.search,
              searchVisible && cls.searchVisible
            )}
          >
            <div className={cls.searchInputContainer}>
              <input ref={inputRef} type='text' className={cls.searchInput} />
            </div>
            <figure
              className={cls.searchCloseContainer}
              onClick={toggleSearchVisibility}
            >
              {closeSVG}
            </figure>
            <div className={cls.divison} />
            <button type='submit' className={cls.searchSubmit}>
              <img className={cls.searchSubmitIcon} src={submitIcon} alt='' />
            </button>
          </form>
        </div>
      </header>
      <Responsive steps={['AfterTablet', 'TabletLandScape']}>
        <Menu />
      </Responsive>
      <Responsive steps={['Mobile', 'TabletPortrait']}>
        <div className={cls.menuMobile}>
          <MenuMobile onMenuClick={handleMenuCLick} />
        </div>
      </Responsive>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.tsx